"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".no-resize{resize:none}.min-h-text{height:320px}.sendConversationMessage{font-size:14px}.sendConversationMessage__termsWrap{display:flex;align-items:center;margin-left:30px}.sendConversationMessage__termsWrap .mat-checkbox{height:16px;margin-right:10px}.sendConversationMessage__termsWrap a{color:#000}.error-cnt{margin-left:15px;font-size:80%;display:inline-block}.emoji-container{position:absolute;bottom:0;right:15px}.mat-checkbox-label .error-cnt{margin-left:5px}.termsAgreementCheckbox .mat-checkbox-layout{margin-bottom:0!important}"];
exports.styles = styles;
